{
    "button.copy": "복사",
    "button.email": "이메일",
    "button.share": "공유하다",
    "button.sms": "SMS",
    "footer.poweredBy": "제공 <linkText>Ice Cream Social<\/linkText>",
    "footer.privacyPolicy": "개인 정보 정책",
    "footer.termsAndConditions": "이용약관",
    "offer.hint": "{conversionGoal, plural, one {친구 #명이 구매하면 보상을} two {#친구가 구매하면 보상이} few {#친구가 구매하면 보상이} many {#친구가 구매하면 보상이} other {#친구가 구매하면 보상이}} 드립니다!",
    "optInMessage": "참여하고 친구들과 공유하려면 제안 및 보상 업데이트에 대해 연락하는 방법을 알려주십시오.",
    "order.confirmed": "주문 번호 {orderId}이 확인되었습니다!",
    "order.details": "주문 세부정보 보기",
    "share.email.duplicateError": "이런! 해당 이메일을 이미 추가했습니다.",
    "share.email.heading": "이메일로 친구 초대",
    "share.email.inputLabel": "친구의 이메일 주소",
    "share.email.inputSubmit": "입력하다",
    "share.email.invitesSubmit": "초대장 보내기",
    "share.email.moreOptions": "더 많은 공유 옵션",
    "share.email.subheading": "아래에 친구의 이메일 주소를 입력하세요",
    "share.general.help": "<bold>문제가있다?<\/bold> 기기에 앱이 설치되어 있지 않으면 앱이 열리지 않을 수 있습니다. 대신 개인 링크로 <bold2>공유하다<\/bold2>를 사용해 보세요.",
    "share.general.linkLabel": "개인 링크를 사용하여 어디서나 공유",
    "share.general.otherOptions": "또는 지금 이 플랫폼에서 공유하세요.",
    "thankyou.dismissCTA": "해고하다",
    "thankyou.heading": "공유해 주셔서 감사합니다!",
    "thankyou.message": "당신은 챔피언입니다! 받은 편지함으로 보상 진행 상황에 대한 업데이트를 보내드립니다.",
    "thankyou.reminder": "공유를 계속하려면 나중에 언제든지 이 제안을 다시 방문할 수 있습니다.",
    "thankyou.shareCTA": "계속 공유",
    "unlock.consentExplanation": "제공해 주신 정보로 연락드리겠습니다. 언제든지 구독을 취소할 수 있지만 제안에 대한 업데이트를 놓칠 수 있습니다.",
    "unlock.consentPolicyExplanation": "우리는 귀하의 개인 정보를 소중하게 생각합니다. 귀하의 정보가 어떻게 사용되는지 알아보려면 <linkText> 개인정보 보호 및 쿠키 정책 <\/linkText> 을 읽으십시오.",
    "unlock.emailConsentOptIn": "이메일 업데이트",
    "unlock.error.invalidEmail": "유효한 이메일을 입력하세요",
    "unlock.error.noConsent": "이 제안에 참여하려면 이메일 통신에 동의하십시오",
    "unlock.input": "귀하의 이메일 주소",
    "unlock.label": "제안 활성화",
    "share.general.copySuccess": "✨ 링크 복사!"
}